var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgErrorCards(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "85px",
    height: "59px",
    viewBox: "0 0 85 59",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "PMVP-Statements",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "No-transactions-available",
    transform: "translate(1.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Illustrative-/-Credit-cards-(ways-to-pay)",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.53
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76.514535,57.220623 L15.314535,57.220623 C11.9493,57.220623 9.194535,54.466623 9.194535,51.100623 L9.194535,20.500623 C9.194535,17.134623 11.9493,14.380623 15.314535,14.380623 L76.514535,14.380623 C79.880535,14.380623 82.634535,17.134623 82.634535,20.500623 L82.634535,51.100623 C82.634535,54.466623 79.880535,57.220623 76.514535,57.220623 Z M52.914535,48.040623 L74.454535,48.040623 M52.914535,23.560623 L74.454535,23.560623 M52.914535,35.800623 L74.454535,35.800623 M9.365589,52.534233 C7.332984,51.825078 5.727249,50.064048 5.333274,47.802708 L0.090729,17.655588 C-0.486081,14.339313 1.755369,11.153853 5.071644,10.577043 L65.365884,0.090423 C68.682159,-0.486387 71.867619,1.755063 72.444429,5.071338 L74.063169,14.380623 M36.792063,14.378022 L63.924318,9.659502",
    id: "Icon"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(17.000000, 22.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#000000",
    strokeWidth: 1.5,
    cx: 14,
    cy: 14,
    r: 14
  }), /*#__PURE__*/React.createElement("g", {
    id: "Core-/-Cross",
    transform: "translate(1.500000, 2.000000)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.4643529,6.33298205 L12.5556675,11.4246675 L17.6466906,6.33298205 C17.95911,6.02056262 18.465642,6.02056262 18.7780614,6.33298205 C19.0904808,6.64540149 19.0904808,7.15193347 18.7780614,7.4643529 L13.6866675,12.5556675 L18.7780614,17.6466906 C19.0904808,17.95911 19.0904808,18.465642 18.7780614,18.7780614 C18.465642,19.0904808 17.95911,19.0904808 17.6466906,18.7780614 L12.5556675,13.6866675 L7.4643529,18.7780614 C7.15193347,19.0904808 6.64540149,19.0904808 6.33298205,18.7780614 C6.02056262,18.465642 6.02056262,17.95911 6.33298205,17.6466906 L11.4246675,12.5556675 L6.33298205,7.4643529 C6.02056262,7.15193347 6.02056262,6.64540149 6.33298205,6.33298205 C6.64540149,6.02056262 7.15193347,6.02056262 7.4643529,6.33298205 Z",
    id: "Icon"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorCards);
export default __webpack_public_path__ + "static/media/error-cards.6d0677b1.svg";
export { ForwardRef as ReactComponent };